const bucket = process.env.GATSBY_FIREBASE_STORAGE_BUCKET;

// Firebase Storage REST URL for a file under pdfs/tech-library/. The `token` value is a placeholder; the bucket allows public reads.
const getTechLibraryFileUrl = (fileName) => {
  const objectPath = `pdfs/tech-library/${fileName}`.replaceAll('/', '%2F');

  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${objectPath}?alt=media&token=123`;
};

export default getTechLibraryFileUrl;
